<div class="text-[#5F5B5B] text-center flex items-center flex-col justify-center text-lg">
    <div class="icon-[5rem] bg-icon-empty-result"></div>
    <p class="mt-4">{{ line1 | translate }}</p>
    <p>{{ line2 | translate }}</p>
</div>
